import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {ParcelsService} from '../../services/parcels.service';

import {ParcelsComponent} from './parcels.component';
import {ParcelModalComponent} from './parcel-modal/parcel-modal.component';
import {ParcelHistoryComponent} from './parcel-history/parcel-history.component';
import {TransitParcelModalComponent} from './transit-parcel-modal/transit-parcel-modal.component';
import {ParcelsListComponent} from './parcels-list/parcels-list.component';
import {ParcelsFilterComponent} from '../../components/parcels-filter/parcels-filter.component';
import {DatetimeModule} from '../../components/datetime/datetime.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {AccountPermissionsService} from '../../services/account-permissions.service';
import {ParcelMassModalComponent} from './parcel-mass-modal/parcel-mass-modal.component';
import {ParcelReminderModalComponent} from './parcel-reminder-modal/parcel-reminder-modal.component';
import {ParcelDetailedViewComponent} from './parcel-detailed-view/parcel-detailed-view.component';
import {CaptureImageModalModule} from '../../components/directory/capture-image-modal/capture-image-modal.module';
import {EnterParcelBarcodeModalComponent} from './enter-parcel-barcode-modal/enter-parcel-barcode-modal.component';
import {AddResidentEmailFormComponent} from './parcel-modal/add-resident-email-form/add-resident-email-form.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        AngularMaterialImportModule,
        CaptureImageModalModule,
        UtilsModule
    ],
    declarations: [
        ParcelsComponent,
        ParcelsListComponent,
        ParcelModalComponent,
        ParcelHistoryComponent,
        TransitParcelModalComponent,
        ParcelsFilterComponent,
        ParcelMassModalComponent,
        ParcelReminderModalComponent,
        ParcelDetailedViewComponent,
        EnterParcelBarcodeModalComponent,
        AddResidentEmailFormComponent
    ],
    exports: [
        ParcelModalComponent,
        TransitParcelModalComponent,
        EnterParcelBarcodeModalComponent
    ],
    providers: [
        ParcelsService,
        AccountPermissionsService
    ]
})
export class ParcelsModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcels.module.ts